<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please Wait...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
    import axios from "axios"
    import ApiService from "@/common/api.service"
    import JwtService from "@/common/jwt.service"
    import {CHECK_AUTH} from "@/store/actions.type"
    import {mapGetters} from "vuex"

    export default {

        data: () => ({
            dialog: true
        }),

        mounted() {
            let state = this.$route.query.state;
            let scope = this.$route.query.scope;
            let code = this.$route.query.code;
            let error = this.$route.query.error;
            let error_description = this.$route.query.error_description;
            if (code !== '') {
                this.finishOrganization(state, scope, code);
            }
        },
        methods: {
            finishOrganization(state, scope, code) {
                let registration = {
                    state: state,
                    scope: scope,
                    code: code
                }
                let token = JwtService.getToken();
                let config = {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
                axios.post('/register_organization/stripe_finish', registration, config)
                    .then(response => {
                        this.$store.dispatch(CHECK_AUTH)                    
                            .then(res => {
                                JwtService.destroyOrganizationToken();
                                this.$router.push(`/`)
                            })
                            .catch(err => {
                                console.log(err)
                            })
                        })
                    .catch(error => {
                        console.log(error)
                    });

            },
            errorOrganization(state, error, error_description) {
                let registration = {
                    state: state,
                    error: error,
                    error_description: error_description
                }
                ApiService.post('/register_organization/stripe_finish', registration)
                    .then(response => {
                    })
                    .catch(error => {
                    });
                this.$router.push(`/`)
            }
        },
        computed: {
            ...mapGetters(["firstLogin"])
        }
    }
</script>

